import { DEFAULT_SEO_KEYWORDS, RouteSeoData } from '../service/seo.service';

export interface PageSeoOptions {
  keywords?: string;
}

/**
 *
 * @param title
 * @param description
 * @param options
 */
export function createPageSeo(title: string, description: string, options: PageSeoOptions = {}): RouteSeoData {
  return {
    title,
    description,
    keywords: options.keywords ?? DEFAULT_SEO_KEYWORDS,
  };
}
